import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import Button from '@mui/material/Button';
import LessonPlayerContext from '../../dashboard/models/LessonPlayerContext';
import React from 'react';
import { useContext } from 'react';
import { useLessonContext } from '../../content/models/LessonContext';

//* For the learner view
export type LessonSubmissionAction = 'submit' | 'withdraw' | 'resubmit';
interface LessonSubmissionPanelProps {
  state: ApiPortfolioState;
  inProgress: boolean;
  onSubmit: (action: LessonSubmissionAction) => void;
}

export const LessonSubmissionPanel = (props: LessonSubmissionPanelProps) => {
  const context = useContext(LessonPlayerContext);
  const { portfolioLocked } = useLessonContext();

  if (props.state === ApiPortfolioState.AssessmentMark) {
    //* While marking, no action can be performed
    return null;
  }

  // Allow learner to withdraw assessment immediately, if they submit it by mistake,
  // but they shouldn't be able to withdraw it when they come back days later
  // (possibly after some kind of deadline).
  if (
    context.lessonState.state === ApiPortfolioState.AssessmentSubmit ||
    context.lessonState.state === ApiPortfolioState.AssessmentMark
  ) {
    return null;
  }

  function getAction(state: ApiPortfolioState): LessonSubmissionAction {
    switch (state) {
      case ApiPortfolioState.AssessmentSubmit:
        return 'withdraw';
      case ApiPortfolioState.AssessmentRetry:
        return 'resubmit';
      default:
        return 'submit';
    }
  }

  function handleClick(action: LessonSubmissionAction) {
    props.onSubmit(action);
  }

  const action = getAction(props.state);
  return (
    <Button
      variant={
        props.state === ApiPortfolioState.AssessmentSubmit
          ? 'text'
          : 'contained'
      }
      color="primary"
      disabled={props.inProgress || portfolioLocked}
      onClick={(_) => handleClick(action)}
    >
      {action}
    </Button>
  );
};
